module.exports = "https://www.gc-qa.gnp.com.mx/91ecd1d36e4a664d226af281c15d5d80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-siniestro.svg
// module id = 1840
// module chunks = 0